import { render, staticRenderFns } from "./Ads_eBoothTypeColumnMenu.vue?vue&type=template&id=954bc8be&"
import script from "./Ads_eBoothTypeColumnMenu.vue?vue&type=script&lang=js&"
export * from "./Ads_eBoothTypeColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports